/**
 * Радиус маркера отверстия на 2D (мм в СК детали).
 * Геометрия выреза в контуре остаётся точной; overlay может быть чуть крупнее для читаемости.
 */
export const holeFaceOverlayRadiusMm = (radiusMm, detailLengthMm, detailWidthMm) => {
    const radius = Number(radiusMm);
    if (!Number.isFinite(radius) || radius <= 0) {
        return 0;
    }
    const ref = Math.max(Number(detailLengthMm) || 0, Number(detailWidthMm) || 0, 1);
    const minRadius = Math.max(5, ref * 0.01);
    return Math.max(radius, minRadius);
};

export const holeSideOverlayRadiusMm = (radiusMm, detailHeightMm) => {
    const radius = Number(radiusMm);
    if (!Number.isFinite(radius) || radius <= 0) {
        return 0;
    }
    const ref = Math.max(Number(detailHeightMm) || 0, 1);
    const minRadius = Math.max(3, ref * 0.08);
    return Math.max(radius, minRadius);
};
